import React from "react";
import AdminMasterLayout from "../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout";
import FAQManagementpage from "../../../subsreens/gcadmin/faqmanagementpage/FAQManagementpage";

const FAQManagement = () => {
  return (
    <AdminMasterLayout>
      <FAQManagementpage />
    </AdminMasterLayout>
  );
};

export default FAQManagement;